export enum CheckoutModalResponseEnum {
    somenteFechar = 0,
    listarRespostas = 1,
    voltarVisaoGeral = 2
}

export enum VerMaisDetalhesModalResponseEnum {
    somenteFechar = 0,
    atualizarRespostas = 1,
    listarRespostas = 2
}